interface Props {
  [key: string]: any
}

export default function QuestionCircleWhiteIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 26 26" {...rest} xmlns="http://www.w3.org/2000/svg">
      <circle cx="13.5" cy="13.5" fill="#fff" r="12.7642" />
      <path
        clipRule="evenodd"
        d="M12.8743 4.62194C9.57348 4.82731 7.84861 6.69654 7.698 10.0768H11.0277C11.0694 8.90587 11.723 8.03054 12.9398 7.90148C14.1342 7.77469 15.2674 8.05919 15.6106 8.87581C15.9814 9.75795 15.1491 10.7831 14.7534 11.2133C14.0211 12.0112 12.8315 12.5933 12.2148 13.4542C11.6103 14.2977 11.5028 15.4076 11.4563 16.766H14.3909C14.4321 15.8975 14.4899 15.0656 14.8851 14.5258C15.5278 13.6487 16.4877 13.2377 17.2921 12.5451C18.0605 11.883 18.8689 11.0851 19.0062 9.85014C19.4183 6.15393 16.4012 4.40183 12.8743 4.62194Z"
        fill="#7D38D6"
        fillRule="evenodd"
      />
      <path
        d="M12.95 21.623C13.9732 21.623 14.8027 20.8061 14.8027 19.7983C14.8027 18.7906 13.9732 17.9736 12.95 17.9736C11.9267 17.9736 11.0972 18.7906 11.0972 19.7983C11.0972 20.8061 11.9267 21.623 12.95 21.623Z"
        fill="#7D38D6"
      />
    </svg>
  )
}
